<section class="wraper-sub">
  <div class="lead-m">
    <div class="top-page-m">
      <div class="top-section">
        <h1 class="page-name">Search Order</h1>
      </div>
      <div class="filter-sub-m">
        <div class="filter-m">
          <div class="filter">
            <div class="fields-m largeField">
              <input type="text" name="search" [(ngModel)]="searchParams.oIdEmail" (change)="rerender()" placeholder="Search by Order ID, Email or Phone">
              <i class="fa fa-search" aria-hidden="true" (change)="rerender()"></i>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                [items]="orderStatus"
                bindLabel="name"
                bindValue="value"
                placeholder="Order Status"
                [(ngModel)]="searchParams.status"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="true"
                (change)="rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
  					        {{ item.name }}
  					    </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="clear-m">
            <div class="clear" (click)="clearFilters()">
              <span>Clear</span>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.502 14.4612L11 14.5L16.3175 8.9606C16.7574 8.50197 16.9996 7.89224 16.9996 7.24366C16.9996 6.59515 16.7574 5.98539 16.3175 5.52676L12.178 1.21004C11.2701 0.263319 9.79293 0.263319 8.88506 1.21004L0.682059 9.76415C0.242217 10.2228 0 10.8325 0 11.4811C0 12.1296 0.242217 12.7394 0.682059 13.198L2.74371 15.3479C2.83711 15.4453 2.96378 15.5 3.09586 15.5H16.502C16.777 15.5 17 15.2675 17 14.9806C17 14.6938 16.777 14.4612 16.502 14.4612ZM7.83365 3.77541L9.14441 5.14226L5.12739 9.33125L3.81663 7.96439L7.83365 3.77541ZM11.8424 7.95567L7.82531 12.1446L5.8317 10.0657L9.84874 5.87674L11.8424 7.95567ZM12.5467 8.69015L13.8575 10.057L12.5138 11.4583L9.84048 14.246L8.52965 12.8791L12.5467 8.69015ZM9.58943 1.94452C10.1089 1.40283 10.9542 1.40283 11.4737 1.94452L15.6132 6.26124C16.1327 6.80297 16.1327 7.68442 15.6132 8.22612L14.5618 9.32256L8.53798 3.04093L9.58943 1.94452ZM1.38636 12.4635C1.13468 12.2011 0.996094 11.8521 0.996094 11.4811C0.996094 11.11 1.13468 10.7611 1.38633 10.4987L3.11226 8.69887L4.77514 10.4329L7.47309 13.2464L8.63816 14.4612H3.30215L1.38636 12.4635Z" fill="#1C212D"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-tables-m">
      <div class="table-responsive">
        <table class="row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
            <tr>
              <th>Sr#</th>
              <th>Order ID</th>
              <th>Timestamp</th>
              <th>Client Info.</th>
              <th>Price / No. of Pages</th>
              <th>Due Date</th>
              <th>Academic Level / Subject</th>
              <th>Assigned To</th>
              <th>Writer D-D</th>
              <th>Order Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <ng-container *ngIf="leads.data && leads.data.length > 0">
            <tbody>
              <tr *ngFor="let lead of leads.data; let indx = index">
                <td>{{indx + 1}}</td>
                <td><a class="id" href="javascript:;" target="_blank" routerLink="/order-detail/{{ lead.id | base64 }}">{{ lead.order_id }}</a></td>
                <td>
                  <p *ngIf="lead.date" class="time-done">{{ lead.date | date }}</p>
                  <p class="time-done">{{ lead.date | date:'shortTime' }}</p>
                </td>
                <td>
                  <p>{{ lead.name }}</p>
                  <p>{{ lead.phone }}</p>
                  <p>{{ lead.email }}</p>
                </td>
                <td>
                  <!-- <p class="price-td">${{ lead.amount }}</p> -->
                  <p class="price-td" [ngClass]="{'fullpay': !lead.half_price, 'halfpay': lead.half_price}">$ {{ lead.amount }}</p>
                  <p class="page-td">{{ lead.pages }} Pages</p>
                </td>
                <td>
                    <p *ngIf="lead.delivery_date == '0000-00-00 00:00:00'">-</p>
                    <ng-container *ngIf="lead.delivery_date != '0000-00-00 00:00:00'">
                        <p>{{ lead.delivery_date | date }}</p>
                        <p>{{ lead.delivery_date | date:'shortTime' }}</p>
                    </ng-container>
                    <p [ngClass]="{'time-elapsed': lead.show_red_dd, 'time-left': !lead.show_red_dd}" *ngIf="lead.dd_remaining_time;else showDash">{{ lead.dd_remaining_time }}</p>
                    <ng-template #showDash>-</ng-template>
                    <!-- <p class="time-left">{{ setDeadlineTimer(lead.delivery_date) }}</p> -->
                </td>
                <td>
                  <p class="time-done">{{ lead.level }}</p>
                  <p class="time-done">{{ lead.subject }}</p>
                  <p class="time-done">{{ lead.title }}</p>
                </td>
                <td>
                    <p *ngIf="lead.writer_id != 0">{{ agentSearch(lead.writer_id, writers) }}</p>
                    <p *ngIf="lead.writer_id == 0">Not Assigned</p>
                </td>
                <td>
                    <p *ngIf="lead.due_date == '0000-00-00 00:00:00'">-</p>
                    <ng-container *ngIf="lead.due_date != '0000-00-00 00:00:00'">
                        <p>{{ lead.writer_delivery_date | date }}</p>
                        <p>{{ lead.writer_delivery_date | date:'shortTime' }}</p>
                    </ng-container>
                    <p [ngClass]="{'time-elapsed': lead.show_red_writer, 'time-left': !lead.show_red_writer}" *ngIf="lead.writer_remaining_time;else showDash">{{ lead.writer_remaining_time }}</p>
                    <ng-template #showDash>-</ng-template>
                   <!-- <p class="time-left">{{ setDeadlineTimer(lead.delivery_date) }}</p> -->
                </td>
                <td>
                  <!-- In case of revision being marked -->
                  <div *ngIf="lead.show_mr_status">
                    <p class="roundedShape">
                        <span class="disabledBox">{{lead.show_mr_status_text}}</span>
                    </p>
                  </div>

                  <!-- For showing status -->
                  <div *ngIf="lead.show_full_status">
                    <p class="roundedShape">
                        <span class="{{ showStatusColor(lead.status, orderStatus) }}">{{ showOrderStatus(lead.status, orderStatus) }}</span>
                    </p>

                    <p *ngIf="lead.show_refund">{{lead.show_refund}} - {{lead.refund_amount}} </p>
                  </div>

                  <!-- If order is unpaid -->
                  <div *ngIf="lead.show_unpaid">
                    <p class="roundedShape">
                        <span class="disabledBox">Unpaid</span>
                    </p>
                  </div>

              </td>
              <td>
                <div class="order-manag-options">
                  <a href="javascript:;" class="edit" target="_blank" routerLink="/modify-order/{{ lead.id | base64 }}">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.7051 0.805083C16.6298 -0.268361 14.8884 -0.268361 13.8131 0.805083L12.8388 1.78468L2.46786 12.1501L2.44582 12.1723C2.44048 12.1777 2.44048 12.1833 2.4348 12.1833C2.42378 12.1999 2.40725 12.2162 2.3964 12.2328C2.3964 12.2383 2.39072 12.2383 2.39072 12.2438C2.3797 12.2603 2.37436 12.2713 2.36317 12.2879C2.35783 12.2934 2.35783 12.2987 2.35232 12.3044C2.34681 12.3209 2.3413 12.3319 2.33562 12.3485C2.33562 12.3538 2.33028 12.3538 2.33028 12.3595L0.0292825 19.2789C-0.0382167 19.4758 0.0130965 19.694 0.161354 19.8402C0.26553 19.943 0.406038 20.0005 0.552229 20C0.61198 19.999 0.671214 19.9897 0.728381 19.9724L7.6424 17.6659C7.64774 17.6659 7.64774 17.6659 7.65342 17.6606C7.67081 17.6554 7.68751 17.648 7.70284 17.6384C7.70714 17.6379 7.71093 17.636 7.71403 17.633C7.73039 17.622 7.75243 17.6108 7.76896 17.5998C7.78532 17.589 7.80202 17.5724 7.81855 17.5614C7.82406 17.5557 7.8294 17.5557 7.8294 17.5504C7.83508 17.5449 7.8461 17.5395 7.85161 17.5284L19.1968 6.18315C20.2703 5.10781 20.2703 3.36644 19.1968 2.29127L17.7051 0.805083ZM7.46625 16.3723L3.63498 12.5412L13.2242 2.95197L17.0554 6.78307L7.46625 16.3723ZM3.09533 13.5595L6.4424 16.9064L1.41646 18.5798L3.09533 13.5595ZM18.4207 5.41242L17.8372 6.00149L14.0057 2.17005L14.595 1.58115C15.2395 0.937154 16.2842 0.937154 16.9289 1.58115L18.4261 3.07836C19.0658 3.7258 19.0634 4.76808 18.4207 5.41242Z" fill="#F07527"/>
                    </svg>
                  </a>
                  <a href="javascript:;">
                    <svg width="19" height="25" viewBox="0 0 19 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.1998 10.577H3.7998V11.5385H15.1998V10.577Z" fill="#F07527"/>
                      <path d="M15.1998 13.4616H3.7998V14.4231H15.1998V13.4616Z" fill="#F07527"/>
                      <path d="M15.1998 16.3462H3.7998V17.3078H15.1998V16.3462Z" fill="#F07527"/>
                      <path d="M9.4998 19.2309H3.7998V20.1924H9.4998V19.2309Z" fill="#F07527"/>
                      <path d="M9.51426 3.60579C9.90776 3.60579 10.2268 3.28291 10.2268 2.88463C10.2268 2.48634 9.90776 2.16347 9.51426 2.16347C9.12075 2.16347 8.80176 2.48634 8.80176 2.88463C8.80176 3.28291 9.12075 3.60579 9.51426 3.60579Z" fill="#F07527"/>
                      <path d="M18.9999 5.7692C18.9999 4.70711 18.1493 3.84611 17.1 3.84611H14.4623C14.1105 3.4505 13.6585 3.14779 13.1392 2.99659C12.7018 2.8693 12.3651 2.52856 12.2393 2.08583C11.897 0.881254 10.8002 0 9.49994 0C8.19975 0 7.10297 0.881194 6.76073 2.08571C6.63474 2.52898 6.29725 2.8693 5.8593 2.99707C5.3406 3.14839 4.88906 3.4508 4.5375 3.84611H1.9C0.850606 3.84611 0 4.70711 0 5.7692V23.0769C0 24.139 0.850606 25 1.9 25C6.26204 25 11.6231 25 17.1 25C18.1494 25 19 24.139 19 23.0769C19 17.6154 18.9999 12.3856 18.9999 5.7692ZM4.75006 5.75369C4.75659 4.90838 5.32089 4.15477 6.12239 3.92099C6.87705 3.70092 7.45697 3.11414 7.67368 2.35151C7.90626 1.53306 8.65723 0.961543 9.49994 0.961543C10.3427 0.961543 11.0937 1.53306 11.3262 2.35157C11.543 3.11468 12.1226 3.70128 12.8765 3.92069C13.6851 4.15609 14.2499 4.91625 14.2499 5.76914V6.73068H4.75006V5.75369ZM17.1 24.0385C12.0261 24.0385 6.96053 24.0385 1.9 24.0385C1.37613 24.0385 0.95 23.6071 0.95 23.0769V5.7692C0.95 5.23903 1.37613 4.80766 1.9 4.80766H3.96281C3.86009 5.10165 3.80261 5.41721 3.80012 5.74618V7.69229H15.2V5.7692C15.2 5.43176 15.1411 5.10868 15.0359 4.80766H17.1C17.6238 4.80766 18.0499 5.23903 18.0499 5.7692C18.0499 8.51819 18.0499 21.4095 18.0501 23.0769C18.05 23.6071 17.6239 24.0385 17.1 24.0385Z" fill="#F07527"/>
                    </svg>
                  </a>
                </div>
              </td>
          </tr>
        </tbody>
        </ng-container>
        </table>
      </div>
    </div>
  </div>
</section>
